// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"OverflowMenu_listWrapper__1m-hL","arrow":"OverflowMenu_arrow__1kc8D","list":"OverflowMenu_list__2rD1B","button":"OverflowMenu_button__3-s0F"};